// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__ZwnMZ","headerNav":"Header_headerNav__ORrCL","stickyNav":"Header_stickyNav__yEUqj"};